module.exports = __webpack_public_path__ + "img/giftCardsStacked2.224e0645.png";